import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Container, SearchHeader, SearchInput, AutoKeyword } from './DashboardSearchInputStyle';
import Magnifier_color from 'assets/icons/Magnifier-color.svg';
import Magnifier from 'assets/icons/Magnifier.svg';
// import CloseButton from "assets/icons/CloseButton.svg";
import BackLinkIcon from 'assets/icons/left_arrow.svg';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const DashboardSearchInput = () => {
   const navigate = useNavigate();
   const handleClick = (name, page = parseInt('0', 10)) => {
      // resetFlowerData();
      navigate(`/dashboard/${name}/${page}`);
   };

   const textRef = useRef(null);
   const [show, setShow] = useState(true);
   const [keywords, setKeywords] = useState([]);
   const [text, setText] = useState('');
   const [suggestions, setSuggestions] = useState([]);

   useEffect(() => {
      const loadFlower = async () => {
         const response = await axios.get('https://api.floway.co.kr/api/flowers/autoComplete');

         setKeywords(response.data.data);
      };
      loadFlower();
   }, []);

   const onSuggestHandler = text => {
      handleClick(text);
   };

   const onChangeHandler = text => {
      let matches = [];
      if (text.length > 0) {
         matches = keywords.filter(keyword => {
            const regex = new RegExp(`${text}`, 'gi');
            return keyword.search_nm.match(regex);
         });
      }
      setSuggestions(matches);
      setText(text);
   };

   const searchFunc = useCallback(e => {
      if (e.key === 'Enter') {
         navigate(`/dashboard/${e.target.value}/${0}`);
      }
      return null;
   }, []);

   return (
      <>
         <Container>
            <SearchHeader>
               <img src={BackLinkIcon} alt="Back Link button" onClick={() => navigate(-1)} />
            </SearchHeader>
            <SearchInput>
               <img src={Magnifier} alt="Magnifier" />
               <input
                  ref={textRef}
                  onChange={e => onChangeHandler(e.target.value)}
                  value={text}
                  type="search"
                  placeholder="꽃 품목 혹은 꽃 이름을 검색해 보세요."
                  onKeyDown={searchFunc}
               />
            </SearchInput>
         </Container>
         {suggestions &&
            suggestions.map((suggestion, i) => (
               <AutoKeyword>
                  <p key={i} onClick={() => onSuggestHandler(suggestion.search_nm)}>
                     <img src={Magnifier_color} alt="Magnifier" />
                     {suggestion.search_nm}
                  </p>
               </AutoKeyword>
            ))}
      </>
   );
};

export default DashboardSearchInput;
